import { render, staticRenderFns } from "./SAttributeEditorComponent.vue?vue&type=template&id=0f7bedd1&scoped=true"
import script from "./SAttributeEditorComponent.vue?vue&type=script&lang=js"
export * from "./SAttributeEditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7bedd1",
  null
  
)

export default component.exports